(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/oddset-constants/assets/javascripts/oddset-constants.js') >= 0) return;  svs.modules.push('/components/sport/oddset-constants/assets/javascripts/oddset-constants.js'); 
'use strict';

var svs = svs || {};

(function(svs) {

  svs.oddset = svs.oddset || {};

  svs.oddset.REGULAR = 1;
  svs.oddset.LIVE = 2;
  svs.oddset.MAX_POSSIBLE_WIN_AMOUNT = 300000;
  svs.oddset.SOCCER = 1000002;
  svs.oddset.HOCKEY = 1000003;
  svs.oddset.TENNIS = 1000007;
  svs.oddset.BADMINTON = 1000043;
  svs.oddset.TABLE_TENNIS = 1000022;
  svs.oddset.BEACH_VOLLEYBALL = 1000023;
  svs.oddset.VOLLEYBALL = 1000049;
  svs.oddset.TROTTING = 1000060;
  svs.oddset.FULLTIME_RESULT = 2;
  svs.oddset.EXTRATIME_RESULT = 3;
  svs.oddset.PENALTIES_RESULT = 4;
  svs.oddset.TENNIS_SET_1 = 5;
  svs.oddset.TENNIS_SET_2 = 6;
  svs.oddset.TENNIS_SET_3 = 7;
  svs.oddset.TENNIS_SET_4 = 8;
  svs.oddset.TENNIS_SET_5 = 13;
  svs.oddset.CURRENT_TENNIS_GAME = 19;
  svs.oddset.GAME_CURRENT = 20;
  svs.oddset.CURRENT_RESULT = 9;
  svs.oddset.EXTRATIME1_RESULT = 10;
  svs.oddset.EXTRATIME2_RESULT = 11;
  svs.oddset.TENNIS_SETS_RESULT = 12;
  svs.oddset.CURRENT_RESULT_PRIORITED = 18;
  svs.oddset.EVENT_1X2 = 1;
  svs.oddset.EVENT_SUBTYPE_FULLTIME = 2;
  svs.oddset.RESULT_EVENT = 3;
  svs.oddset.NEUTRAL_RESULT_POSITION = 3;
  svs.oddset.HOME_WIN_OUTCOME = 'HomeWin';
  svs.oddset.AWAY_WIN_OUTCOME = 'AwayWin';
  svs.oddset.DRAW_OUTCOME = 'Draw';
  svs.oddset.NEUTRAL_OUTCOME = 'Neutral';
  svs.oddset.TWO_WAY = 2;
  svs.oddset.HALFTIME_FULLTIME_EVENT = 2;
  svs.oddset.OVER_UNDER_EVENT = 4;
  svs.oddset.DOUBLECHANCE_EVENT = 5;
  svs.oddset.HANDICAP_EVENT = 6;
  svs.oddset.FIRST_SCORER_EVENT = 8;
  svs.oddset.HEAD_TO_HEAD_EVENT = 12;
  svs.oddset.LAST_SCORER_EVENT = 13;
  svs.oddset.MAX_NUMBER_OF_COUPONS = 10;
  svs.oddset.MAX_NUMBER_OF_BETS = 10;
  svs.oddset.EVENT_STATE_ID_CLOSED = 4;
  svs.oddset.MAX_BET_AMOUNT = 500;
  svs.oddset.MIN_BET_AMOUNT = 10;
  svs.oddset.HOME_WIN_TEAM_ID = 0;
  svs.oddset.AWAY_WIN_TEAM_ID = 1;
  svs.oddset.NEUTRAL_ID = 2;
  svs.oddset.EVENT_TYPE_ID_SCORECAST = 32;
  svs.oddset.EXTRAINFO_NO_GOAL = '0';
  svs.oddset.EXTRAINFO_SELF_GOAL = '1';
  svs.oddset.PAYMENT_VERIFCATION_ERROR = 777;
  svs.oddset.LIVE_VERIFICATION_ERROR = 888;
  svs.oddset.UPDATE_TIMEOUT = 10000;
  svs.oddset.LIVE_CACHE_TIME = 5;
  svs.oddset.REGULAR_CACHE_TIME = 60;
  svs.oddset.STATE_DEFINED = 1;
  svs.oddset.STATE_OPEN = 2;
  svs.oddset.STATE_CLOSED_REGULAR = 3;
  svs.oddset.STATE_CLOSED = 4;
  svs.oddset.STATE_FINALIZED = 20;
  svs.oddset.MATCH_STATUS_CANCELLED = 26;
  svs.oddset.SCORER_SPECIAL_GROUP = 19;
  svs.oddset.EXACT_NUMBER_OF_GOALS_GROUP = 21;

  svs.oddset.MODE_SEARCH = 'search';
  svs.oddset.MODE_TIME = 'time';
  svs.oddset.MODE_LANGEN = 'langen';
  svs.oddset.MODE_EXTRA = 'extra';

  if (typeof exports === 'object') {
    module.exports = svs.oddset;
  }
})(svs);

 })(window);